import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../../contexts/AuthContext';

const userHasRole = (user, role) =>
  user?.roles?.some((currentRole) => currentRole === role || currentRole === `ROLE_${role}`);

const PrivateRoute = ({ children, requiredRole = null, requiredRoles = null }) => {
  const { user, loading, hasRole, getDefaultRoute } = useAuth();

  if (loading) {
    return (
      <div 
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const rolesToCheck = requiredRoles || (requiredRole ? [requiredRole] : []);

  if (rolesToCheck.length > 0) {
    const hasRequiredRole = rolesToCheck.some((role) =>
      userHasRole(user, role) || (typeof hasRole === 'function' && hasRole(role))
    );

    if (!hasRequiredRole) {
      return <Navigate to={getDefaultRoute ? getDefaultRoute() : '/leave'} replace />;
    }
  }

  return children;
};

export default PrivateRoute;
